import React, { useRef, useState, useEffect } from "react";
import "@styles/pages/Home/Home.scss";
import HomeKv from "@pages/Home/HomeKv";
import { useSelector, useDispatch } from "react-redux";
import ExclusiveMemberPrivileges from "@pages/Home/ExclusiveMemberPrivileges";
import EarnEveryDollarFlexRedeem from "@pages/Home/EarnEveryDollarFlexRedeem";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Box, Typography, useMediaQuery } from "@mui/material";
import EventSection from "@sections/EventSection";
import VideoSection from "@sections/VideoSection";
import BlogSection from "@sections/BlogSection";
import Cookies from "@components/ui/Cookies";
import { gaEvent } from "@utils/gaEvent";

const Home = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language;
  const isChinese = i18n.language === "hk";
  const is1280px = useMediaQuery("(max-width:1280px)");
  const kvRef = useRef(null);
  const [showFixed, setShowFixed] = useState(false);
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 當 HomeKv 可見比例 < 0.5 就顯示
        setShowFixed(entry.intersectionRatio < 0.5);
      },
      {
        root: null,
        threshold: 0.5, // 元素剩返 50% 可見時觸發
      }
    );

    if (kvRef.current) {
      observer.observe(kvRef.current);
    }

    return () => {
      if (kvRef.current) {
        observer.unobserve(kvRef.current);
      }
    };
  }, []);

  return (
    <Box className="home-page-container">
      {showFixed && (
        <Box className="fixed-container">
          {!memberInfoData && (
            <img
              onClick={() => {
                gaEvent("clubs_homepage", "join_clubs", "join_clubs_button_3");
                navigate("/login");
              }}
              className="join-now-button"
              src={
                isChinese
                  ? `${process.env.PUBLIC_URL}/assets/images/home/join_now_button_hk.gif`
                  : `${process.env.PUBLIC_URL}/assets/images/home/join_now_button_hk_en.gif`
              }
            />
          )}
          <a
            href="https://api.whatsapp.com/send/?phone=85236984698&text=Subscribe+to+Samsung+HK+WhatsApp+%E8%A8%82%E9%96%B1+Samsung+HK+WhatsApp&type=phone_number&app_absent=0"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              gaEvent("clubs_homepage", "whatsapp_button", "whatsapp_button");
            }}
          >
            <img
              className="whatsapp-icon"
              src={`${process.env.PUBLIC_URL}/assets/images/home/whatsapp.png`}
            />
          </a>
        </Box>
      )}
      {/* 加個 wrapper 去做 observer */}
      {/* for nav bar 80 hieght & kv */}
      <Box sx={{ paddingTop: is1280px ? "" : "80px" }} ref={kvRef}>
        <HomeKv />
      </Box>

      <Box id="member_privileges">
        <ExclusiveMemberPrivileges />
      </Box>
      <EarnEveryDollarFlexRedeem />
      {/* Update by Nic 2026-06-18 */ }
      <Box className="event-section-title">
        <Typography className="title">
            <Trans i18nKey="generic:event" />
        </Typography>
      </Box>
      <EventSection subPage/>
      <VideoSection />
      <BlogSection />
      <Box className="cookies-section">
        <Cookies />
      </Box>
    </Box>
  );
};

export default Home;
